import styled from "styled-components";
import { useState } from "react";
import { ReactComponent as ReloadIcon } from "../../../assets/img/icons/reload.svg";
import Button from "./Button";

const SearchFieldBtn = (props) => {
  const { placeholder, btnText, onClick, handleResetInput } = props;
  const [input, setInput] = useState("");

  const formSubmit = (e) => {
    e.preventDefault();
    onClick(input);
  };

  return (
    <>
      <Wrapper>
        <div className="search-wraper">
          <form onSubmit={(e) => formSubmit(e)}>
            <div className="search-bar">
              <a onClick={(e) => formSubmit(e)} className="refresh-search" href="javascript: void(0);">
                <ReloadIcon />
              </a>
              <div className="search-terms">
                <input
                  type="text"
                  name="search"
                  className="search-input"
                  value={input}
                  onChange={(e) => {
                    if (e.target.value === "") {
                      if (handleResetInput) handleResetInput();
                    }
                    setInput(e.target.value);
                  }}
                  placeholder={placeholder}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="btn-wrapper">
              <Button label={btnText} value={btnText} />
            </div>
          </form>
        </div>
      </Wrapper>
    </>
  );
};

export default SearchFieldBtn;

const Wrapper = styled.div`
  position: relative;
  padding-top: 5px;
  padding-bottom: 5px;
  width: 100%;
  z-index: 2;
  .search-bar {
    .refresh-search {
      border-right: 1px solid #dddddd;
      margin: 7px;
      padding-right: 8px;
    }
    border-radius: 27px;
    background: #ffffff;
    border: 1px solid #dadada;
    display: flex;
    height: 40px;
    width: 100%;
    z-index: 9;
    position: relative;
    .search-terms {
      width: 100%;
      display: flex;
      flex-wrap: no-wrap;
      .search-input {
        width: 100%;
        display: flex;
        flex-grow: 1;
        padding-top: 3px;
        border: none;
        outline: none;
        border-radius: 27px;
      }
      .search-input::placeholder {
        font-size: 18px;
        color: #c1c1c1;
        font-family: "robotoregular", sans-serif;
        font-style: italic;
      }
    }
  }
  .btn-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
      top: 5px;
    }
  }
`;
